import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly isDarkMode = new BehaviorSubject<boolean>(false);
  public isDarkMode$ = this.isDarkMode.asObservable();

  constructor() {
    // Check system preference or saved preference
    this.initializeTheme();
  }

  // El modo claro se retiró: la app es SOLO oscura. Se ignora cualquier preferencia
  // guardada ('light' de antes) y la del sistema operativo, y se borra la clave para que
  // no quede un 'light' huérfano en localStorage.
  public initializeTheme(): void {
    try {
      localStorage.removeItem('synapse-theme');
    } catch {
      // storage bloqueado: da igual, el tema no depende de él
    }
    this.setTheme(true);
  }

  public setTheme(isDark: boolean): void {
    this.isDarkMode.next(isDark);
    
    // Update document attribute for PrimeNG
    const htmlElement = document.documentElement;
    
    if (isDark) {
      htmlElement.dataset['theme'] = 'dark';
      htmlElement.classList.add('p-dark');
    } else {
      htmlElement.dataset['theme'] = 'light';
      htmlElement.classList.remove('p-dark');
    }
  }

}
